import React from 'react';

/** 列表用：如 8/24 17:41；偏旧则追加标记 */
export function formatAnalyzedAt(iso, { stale } = {}) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const text = d.toLocaleString('zh-CN', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  return stale ? `${text}·偏旧` : text;
}

export function ActionBadge({ action, label }) {
  const cls = action || 'hold';
  const text = label || {
    hold: '持有',
    hold_reduce: '持有/减仓',
    reduce: '减仓',
    sell: '卖出',
    blocked: '不可建议'
  }[cls] || '—';
  return <span className={`action-badge ${cls}`}>{text}</span>;
}

export function ScoreRing({ score }) {
  const val = Number.isFinite(Number(score)) ? Math.max(0, Math.min(100, Number(score))) : null;
  return (
    <div className="score-ring" style={{ '--score': val ?? 0 }}>
      <span>{val == null ? '—' : val}</span>
    </div>
  );
}

export function DimensionBars({ dimensions }) {
  if (!dimensions) return null;
  const entries = [
    ['intrinsic', '产品内生'],
    ['macro', '宏观匹配'],
    ['personal', '持仓视角'],
    ['ops', '操作约束']
  ];
  return (
    <div>
      {entries.map(([key, label]) => {
        const dim = dimensions[key] || {};
        const score = Number(dim.score) || 0;
        return (
          <div className="dim-bar-row" key={key}>
            <span>{label}</span>
            <div className="dim-bar-track">
              <div className="dim-bar-fill" style={{ width: `${score}%` }} />
            </div>
            <span>{score}</span>
          </div>
        );
      })}
    </div>
  );
}

export function SignalList({ signals }) {
  const list = signals || [];
  if (!list.length) return <p className="decision-muted">暂无触发信号</p>;
  return (
    <ul className="signal-list">
      {list.map((s) => (
        <li key={s}>{s}</li>
      ))}
    </ul>
  );
}
